// extracted by mini-css-extract-plugin
export default {"generatedImageBox":"GeneratedImage_generatedImageBox__vuPAL","regenerateImg":"GeneratedImage_regenerateImg__9ozuO","downloadImg":"GeneratedImage_downloadImg__ZWQ8D"};